import type { BillingMetronomeProfileResponse } from '@customerio/hydra-ui-api';

import { BillingSystem } from '../types';
import type { BillingPlan } from '../types';
import { PlanType } from '../plans';

export type MetronomeSubscriptionBillingPlan = BillingMetronomeProfileResponse &
  BillingPlan & {
    billingSystem: typeof BillingSystem.Metronome;
  };

function resolvePlanType(wireType: string): PlanType {
  const map: Record<string, PlanType> = {
    trial: PlanType.Essentials,
    startup: PlanType.Startup,
    essentials: PlanType.Essentials,
    premium: PlanType.Premium,
    enterprise: PlanType.Enterprise,
  };
  return map[wireType] ?? PlanType.NotReportable;
}

export function metronomeProfileToBillingPlan(wire: BillingMetronomeProfileResponse): MetronomeSubscriptionBillingPlan {
  return {
    ...wire,
    billingSystem: BillingSystem.Metronome,
    basePrice: wire.base_price,
    intervalDisplayName: wire.interval_name,
    includedCustomers: 0,
    includedProfiles: wire.included_profiles,
    includedObjects: 0,
    includedMessages: wire.included_emails,
    customerOverageRate: wire.profile_overage_rate,
    profileOverageRate: wire.profile_overage_rate,
    objectOverageRate: '0',
    messageOverageRate: wire.email_overage_rate,
    canCancel: wire.can_cancel,
    planType: resolvePlanType(wire.plan_type),
    featureGroups: [],
    name: wire.plan_display_name,
    isMauPricing: false,
    isPaidAnnually: false,
    annualPrice: 0,
    highlights: [],
    isTrial: wire.is_trial,
  };
}
